import { Body, Controller, Post } from "@nestjs/common";
import { PointTypeCreateDto, PointTypesToggleDto } from "./dtos";
import { PointTypeService } from "./point-type-service";
import { ApiBody, ApiTags } from "@nestjs/swagger";
  import {  CommonResponseModel } from '@needle-management/shared-models';
import {PointTypesResponse} from '@needle-management/shared-models'

@ApiTags('Point Types')
@Controller('point-types')
export class PointTypeController {
  constructor(private readonly pointTypeService: PointTypeService) { }

 @ApiBody({ })
  @Post('/createPointTypes')
    async createPointTypes(@Body() req: PointTypeCreateDto): Promise<CommonResponseModel> {
        return await this.pointTypeService.createPointTypes(req);
    }
    
  @Post('/getAllPointTypes')
  async getAllPointTypes(@Body() dto:{}): Promise<PointTypesResponse> {
     return await this.pointTypeService.getAllPointTypes(dto);
    }


  @Post('/togglePointTypes')
  async togglePointTypes(@Body() dto: PointTypesToggleDto): Promise<CommonResponseModel> {
    return await this.pointTypeService.togglePointTypes(dto);
  }


  @Post('/getActivePointType')
  async getActivePointType(): Promise<CommonResponseModel> {
      return await this.pointTypeService.getActivePointType();
  }


}